import React from "react";
import { DateTime } from "luxon";
import Link from "next/link";
import { ButtonType } from "components/atoms/Button/types";
import { CompetitionDTO } from "types";
import { Span } from "utils/styling/typography.styled";
import * as Styled from "./CompetitionList.styled";
interface CompetitionListProps {
  competitions: CompetitionDTO[];
  onCompetitionClick: (compId: string) => void;
}
const CompetitionList: React.FC<CompetitionListProps> = ({
  competitions,
  onCompetitionClick
}) => {
  const truncateDescription = (description: string, length: number) => {
    if (description.length > length) {
      return `${description.substring(0, length)}...`;
    }
    return description;
  };
  const formatDate = (dateString: string) => {
    const options: Intl.DateTimeFormatOptions = {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric"
    };
    return new Date(dateString).toLocaleDateString("UTC", options);
  };
  const calculateTimeLeft = (endDate: string) => {
    const end = DateTime.fromISO(endDate, {
      zone: "utc"
    });
    const now = DateTime.now().setZone("utc");
    const difference = Number(end) - Number(now);
    let timeLeft = {};
    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor(difference / (1000 * 60 * 60) % 24),
        minutes: Math.floor(difference / 1000 / 60 % 60),
        seconds: Math.floor(difference / 1000 % 60)
      };
    }
    return timeLeft;
  };
  const sortedCompetitions = competitions.sort((a, b) => {
    return new Date(a.endDate).getTime() - new Date(b.endDate).getTime();
  });
  return <Styled.ScrollableTable data-sentry-element="unknown" data-sentry-component="CompetitionList" data-sentry-source-file="index.tsx">
            <thead>
                <tr>
                    <Styled.Th data-sentry-element="unknown" data-sentry-source-file="index.tsx">Title</Styled.Th>
                    <Styled.Th data-sentry-element="unknown" data-sentry-source-file="index.tsx">Description</Styled.Th>
                    <Styled.Th data-sentry-element="unknown" data-sentry-source-file="index.tsx">End Date</Styled.Th>
                    <Styled.Th data-sentry-element="unknown" data-sentry-source-file="index.tsx">Time Left</Styled.Th>
                    <Styled.Th data-sentry-element="unknown" data-sentry-source-file="index.tsx"></Styled.Th>
                </tr>
            </thead>
            <tbody>
                {sortedCompetitions.map(comp => <Link key={comp.id} href={`/competitions/${comp.id}`} passHref>
                        <Styled.Tr key={comp.id}>
                            <Styled.Td>
                                <Span>{comp.title}</Span>
                            </Styled.Td>
                            <Styled.Td>
                                {truncateDescription(comp.description, 50)}
                            </Styled.Td>
                            <Styled.Td suppressHydrationWarning>
                                {formatDate(comp.endDate)}
                            </Styled.Td>
                            <Styled.Td>
                                {Object.entries(calculateTimeLeft(comp.endDate)).map(([key, value]) => <Span key={key}>
                                        {value as string} {key}{" "}
                                    </Span>)}
                            </Styled.Td>
                            <Styled.ButtonContainer>
                                <Styled.Button variant={ButtonType.SECONDARY} onClick={() => onCompetitionClick(comp.id)}>
                                    View Details
                                </Styled.Button>
                            </Styled.ButtonContainer>
                        </Styled.Tr>
                    </Link>)}
            </tbody>
        </Styled.ScrollableTable>;
};
export default CompetitionList;